import permissions from '@/enums/permissions';

const silvia = [
    {
        path: '/silvia',
        name: 'silvia',
        component: () => import('@/views/pages/Silvia/silvia.vue'),
        meta: {
            hideNavbar: true,
            permissions: permissions.silvIA,
        },
    },
];

export default silvia;
